import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CheckboxControl from '../components/CheckboxControl';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import { FOLLOWING, followingEnumTransKey } from '../enums';

import {
  Container,
} from '../styles';

const Invoice = ({ isOpen, onClick, onApply, following }) => {
  const [selectedItem, setSelectedItem] = useState(following);

  useEffect(() => {
    if(following?.length < 1) {
      setSelectedItem([]);
    }
  }, [following]);

  const label = Object.values(FOLLOWING);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  return (
    <NFFilter
      label="Acompanhamento"
      isOpen={isOpen}
      // isOpen
      onClick={onClick}
    >
      <FilterForm
        label="Filtrar por acompanhamento"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={followingEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  following: state.tracking.filters.following,
});

export default connect(mapStateToProps)(Invoice);
